import { useMemo } from 'react';
import { parseDate } from 'utils/datetime';
import { ValidDateRange } from './types';

/**
 * If a @ValidDateRange is provided, it returns the [startDate, endDate] as two Dates.
 * Otherwise it returns [undefined, undefined]
 *
 * @param validDateRange
 * @returns [Date | undefined, Date | undefined]
 */
export const useStartAndEndDate = (
  validDateRange?: ValidDateRange,
): [Date | undefined, Date | undefined] => {
  const startDate = useMemo(() => {
    return validDateRange?.startDate ? parseDate(validDateRange?.startDate) : undefined;
  }, [validDateRange?.startDate]);

  const endDate = useMemo(() => {
    return validDateRange?.endDate ? parseDate(validDateRange?.endDate) : undefined;
  }, [validDateRange?.endDate]);

  return [startDate, endDate];
};
